document.documentElement.classList.add('js');
document.querySelectorAll('[data-menu-toggle]').forEach((toggle) => {
  toggle.addEventListener('click', () => {
    const menu = document.getElementById(toggle.getAttribute('aria-controls'));
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    menu.hidden = expanded;
  });
});
if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.querySelectorAll('video[autoplay]').forEach((video) => video.pause());
}
